if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.productHandle = this.dataset.productHandle;
        this.locale = this.dataset.locale || false;
        this.recentlyViewed = [];
        this.filteredProducts = [];
    }

    connectedCallback() {
      this.updateLocalStorage();
      if (!this.recentlyViewed) return;

      this.populateRecentlyViewed();
    }

    async populateRecentlyViewed() {                
      for (let i = 0; i < this.recentlyViewed?.length; i++) {
        const productHandle = this.recentlyViewed[i];
        if (i > 8 || !productHandle) break;
        
        if (productHandle !== this.productHandle) {
          await fetch(`/products/${productHandle}.json`)
            .then((response) => {
              if (!response.ok) return;
              return response.json();
            })
            .then((data) => {
              const product = data?.product;
              if (!product) return;
              const tags = product.tags.split(',').map(item => item.trim())
              const bannedtags = ['base-product', 'hide-product']
                          
              if (!bannedtags.some(i => tags.includes(i))) this.filteredProducts.push(product.handle);
            })
            .catch((err) => console.error(`Recently Viewed Products Module: ${err}`));
        }
      }
      
      if (!this.filteredProducts.length || this.filteredProducts.length === 1) {
        this.closest('.shopify-section')?.remove();
        return;
      }
      
      this.innerHTML = `
        <div class="pl-4 lg:pl-6 relative z-0 mx-auto container">
          <div class="flex flex-col items-center overflow-hidden">
            <div class="w-full relative z-1 flex justify-between pr-4 lg:pr-6">
              <div class="pt-3 pb-6 lg:pb-12 max-w-48 lg:max-w-80">
                <h2>Recently Viewed</h2>
              </div>
              <div class="max-md:absolute max-md:z-10 max-md:w-full max-md:top-[230%] flex justify-between gap-8 w-[6.5rem]">
                <button
                  class="h-11 w-11 min-w-11 arrow-carousel-secondary transform -scale-x-100 disabled:opacity-0 disabled:pointer-events-none"
                  data-prev-recently-viewed>
                  <span class="block w-4 h-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 14 9" fill="none">
                      <path d="M0.5 4.5H12.5M12.5 4.5L9.07143 1M12.5 4.5L9.07143 8" stroke="currentColor"/>
                    </svg>
                  </span>
                </button>
                <button
                  class="h-11 w-11 min-w-11 arrow-carousel-secondary disabled:opacity-0 disabled:pointer-events-none"
                  data-next-recently-viewed>
                  <span class="block w-4 h-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 14 9" fill="none">
                      <path d="M0.5 4.5H12.5M12.5 4.5L9.07143 1M12.5 4.5L9.07143 8" stroke="currentColor"/>
                    </svg>
                  </span>
                </button>
              </div>
            </div>
            <div class="relative w-full min-[1920px]:w-[1920px] max-lg:pl-4 mx-auto">
              <swiper-container 
                class="overflow-visible px-0 lg:pl-4" 
                inject-styles='[":host .swiper {overflow: visible}"]' 
                slides-per-view="2"
                space-between="16"
                breakpoints='{"1024":{"slidesPerView":5}}'
                navigation-prev-el="[data-prev-recently-viewed]"
                navigation-next-el="[data-next-recently-viewed]"
              >
                ${this.filteredProducts.slice(0, 9).map((product) => `
                  <swiper-slide>
                    <intersection-loader 
                      class="block aspect-[249/367] w-full"
                      data-url="${this.locale ? `/${this.locale}` : ``}/products/${product}" 
                      data-section-id="carousel-product-tile">
                    </intersection-loader> 
                  </swiper-slide>
                `).join('')}
              </swiper-container>
            </div>
          </div>
        </div>
      `;

      // const swiperEl = this.querySelector('swiper-container');
      // if (swiperEl && typeof swiperEl.initialize === 'function') {
      //   swiperEl.initialize();
      // }
    }

    updateLocalStorage() {
      if (localStorage.getItem('bsn:recentlyViewedProducts')) {
        this.recentlyViewed = [...new Set([...localStorage.getItem('bsn:recentlyViewedProducts')?.split(',')])].slice(0, 10) ?? [];
      }

      if ((this.recentlyViewed[this.productHandle]) || !this.productHandle) return;
      localStorage.setItem('bsn:recentlyViewedProducts', `${this.productHandle}${this.recentlyViewed ? `,${this.recentlyViewed}` : ''}`);
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}